var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    stroke: "none",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.018,
    cy: 9.363,
    r: 0.522
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.018,
    cy: 9.363,
    r: 0.522
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.018,
    cy: 11.987,
    r: 0.522
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.018,
    cy: 11.987,
    r: 0.522
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.018,
    cy: 11.987,
    r: 0.522
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.018,
    cy: 9.363,
    r: 0.522
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.153,1.175l-4.3,0l0,-0.617c0,-0.308 -0.25,-0.558 -0.558,-0.558c-0.308,-0 -0.558,0.25 -0.558,0.558l-0,0.635c-0.961,0.082 -1.746,0.445 -2.315,1.045c-0.638,0.673 -1.014,1.661 -1.014,2.951l0,6.734c0,1.305 0.375,2.308 1.01,2.992c0.652,0.701 1.587,1.085 2.747,1.085l5.67,0c1.162,0 2.096,-0.378 2.746,-1.067c0.637,-0.675 1.011,-1.665 1.011,-2.953l-0,-6.791c0.003,-1.289 -0.369,-2.277 -1.006,-2.951c-0.567,-0.6 -1.352,-0.963 -2.317,-1.045l0,-0.635c0,-0.308 -0.25,-0.558 -0.558,-0.558c-0.308,0 -0.558,0.25 -0.558,0.558l-0,0.617Zm3.323,5.451l-0,5.354c-0,0.949 -0.238,1.69 -0.707,2.187c-0.455,0.482 -1.12,0.717 -1.934,0.717c0,-0 -5.67,-0 -5.67,-0c-0.81,-0 -1.474,-0.239 -1.929,-0.729c-0.472,-0.507 -0.712,-1.264 -0.712,-2.232l0,-5.297l10.952,0Zm-3.323,-4.335l-4.3,0l0,0.716c0,0.308 -0.25,0.558 -0.558,0.558c-0.308,0 -0.558,-0.25 -0.558,-0.558l-0,-0.692c-0.618,0.069 -1.132,0.297 -1.505,0.691c-0.469,0.495 -0.708,1.234 -0.708,2.183l0,0.321l10.952,0l-0,-0.323c0.002,-0.948 -0.233,-1.687 -0.701,-2.182c-0.372,-0.394 -0.886,-0.621 -1.506,-0.69l0,0.692c0,0.308 -0.25,0.558 -0.558,0.558c-0.308,0 -0.558,-0.25 -0.558,-0.558l-0,-0.716Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5de7c24cc3e1d30420a311071374a6ff.svg";
export { ForwardRef as ReactComponent };